import { render, staticRenderFns } from "./68.vue?vue&type=template&id=d10cb6ec&scoped=true&"
var script = {}
import style0 from "./68.vue?vue&type=style&index=0&id=d10cb6ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10cb6ec",
  null
  
)

export default component.exports